<template>
  <header ref="headerRef" class="print:hidden" :class="[
    'rounded-b-[30px] m-0 bg-[#092E87]',
    isSticky
      ? 'fixed top-0 left-0 w-full z-50 pt-[20px] laptop:pt-[10px] pb-[70px] laptop:pb-[80px]'
      : 'relative h-full pt-[30px] laptop:pt-[20px] pb-[50px] laptop:pb-[50px]'
  ]"
>
    <div
class="" :class="[
      'laptop:container laptop:mx-auto flex items-center justify-between',
      isSticky ? 'px-0' : 'px-[15px] '
    ]"
>
      <div class="flex items-center mobile:gap-2 tablet:gap-[20px]">
        <div v-if="isBackAllow && $route.name !== 'job-invoice'" @click="backPage()" :class="[
          'cursor-pointer laptop:hidden w-[24px] h-[24px] tablet:ml-2.5 p-1 flex items-center justify-center rounded-full bg-opacity-10 bg-[#FFFFFF] text-[#fff]',
          isSticky ? '' : 'hidden'
        ]"
>
          <img src="../../assets/images/back-arrow-icon.png" class="w-full h-full">
        </div>
        <div
:class="[
          'object-contain rounded-full',
          isSticky ? 'w-[45px] h-[45px] laptop:w-[50px] laptop:h-[50px]' : 'w-[50px] h-[50px] laptop:w-[80px] laptop:h-[80px]'
        ]"
>
          <img src="../../assets/images/fyxifyLogo.png" alt="logo" class="img-fluid">
        </div>
        <p
:class="[
          'm-0 font-lato font-bold text-[#fff]',
          isSticky ? 'text-base laptop:text-[20px]' : 'text-[20px] laptop:text-[30px]'
        ]"
>
{{ $route?.meta?.title ?? '' }}
</p>
      </div>
      <div v-if="!setCompanyInfo" class="w-[150px] h-[40px] laptop:w-[230px] laptop:h-[70px] tablet:pr-2.5 laptop:pr-0 tablet:justify-center mobile:flex justify-end items-center">
        <img :src="saveCompanyInfo.company_logo" alt="logo" class="w-auto h-full object-contain" />
      </div>
    </div>
    <div @click="backPage()" v-if="isBackAllow && !hideBackArrow && !isSticky && $route.name !== 'job-invoice'"
      class="cursor-pointer px-[15px] pt-[10px] laptop:hidden transition-all duration-300">
      <div
        class="w-[24px] h-[24px] p-1 flex items-center justify-center rounded-full bg-opacity-10 bg-[#FFFFFF] text-[#fff]"
>
        <img src="../../assets/images/back-arrow-icon.png" class="w-full h-full">
      </div>
    </div>
  </header>

  <!-- Spacer only visible when sticky -->
  <div v-if="isSticky" :style="{ height: headerHeight + 'px' }"></div>
  <div class="pageHeaderPg">
    <div v-if="Object.keys(maintenanceBannerData).length > 0" class="notification-banner" @click="showModal">
      <span class="notification-message">
        {{ maintenanceBannerData.title }}
      </span>
    </div>
  </div>


  <!-- Modal -->
  <div
id="maintenanceModal" ref="maintenanceModal" class="modal fade modal-md fxConfirm" tabindex="-1" data-bs-backdrop="static"
    data-bs-keyboard="false" aria-hidden="true" aria-labelledby="exampleModalLabel" aria-modal="true" role="dialog"
>
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content custom-popup">
        <div class="modal-body">
          <div class="text-center mb-3">
            <img src="../../assets/images/banner-img.png" alt="Top Banner" class="pageHeaderPg-modal-top-image">
          </div>
          <h4 class="text-center pageHeaderPg-modal-title mb-2">
            {{ maintenanceBannerData.title }}
          </h4>
          <p class="text-center pageHeaderPg-modal-content-text" v-html="maintenanceBannerData.description" />
          <div class="text-center mt-4">
            <button class="pageHeaderPg-modal-button" data-bs-dismiss="modal">
Dismiss
</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapGetters, mapActions
} from "vuex";
import { Modal } from "bootstrap";
export default {
  data() {
    return {
      isSticky: false,
      lastScrollTop: 0,
      hideBackArrow: false,
      headerHeight: 0
    };
  },

  computed: {
    ...mapGetters(["setCompanyInfo", "saveCompanyInfo", "maintenanceBannerData"]),

    isBackAllow() {
      if (this.$route.name == 'AppointmentDetail' || this.$route.name == 'QuoteDetail' || this.$route.name == 'job-detail') {
        return false
      } else {
        return true
      }
    }
  },

  watch: {},

  mounted() {
    this.getData()
    this.getMaintenanceBannerData({ app_type: 'technician-web' })

    this.$refs.maintenanceModal.addEventListener('shown.bs.modal', () => {
      document.documentElement.style.overflow = 'hidden';
    });

    this.$refs.maintenanceModal.addEventListener('hidden.bs.modal', () => {
      document.documentElement.style.overflow = '';
    });
    this.headerHeight = this.$refs.headerRef.offsetHeight;
    window.addEventListener("scroll", this.handleScroll);
  },

  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    ...mapActions(["getCompanyInfo", "getMaintenanceBannerData"]),
    getData() {
      let user = JSON.parse(localStorage.getItem('user'))
      if (user != null) {
        this.getCompanyInfo({
        });
      }
    },
    showModal() {
      this.modal = new Modal(this.$refs.maintenanceModal);
      this.modal.show();
      document.documentElement.style.overflow = 'hidden'; // html
    },
    handleScroll() {
      let st = window.scrollY || document.documentElement.scrollTop;
      // 🔹 Make header sticky after scrolling 50px
      this.isSticky = st > 0;
      // 🔹 Hide back arrow on scroll down
      if (st > this.lastScrollTop) {
        this.hideBackArrow = true;
      } else {
        this.hideBackArrow = false;
      }
      this.lastScrollTop = st <= 0 ? 0 : st;
    },
    backPage() {
      this.$router.go(-1)
    }
  }
};
</script>

<style>
/* .companyLogo {
    width: 150px;
    height: 100px;
    padding: 1rem !important;
    top: 20px;
    position: relative;
}
.companyLogo img {
    width: 150px !important;
    height: 70px;
    -o-object-fit: contain;
    object-fit: contain;
} */
.companyLogo {
  width: 150px;
  height: 50px;
  right: 10px;
  position: relative;
  padding: 0 !important;
}

.companyLogo img {
  width: 150px !important;
  height: 50px;
  -o-object-fit: contain;
  object-fit: contain;
  display: flex;
  align-items: center;
  justify-content: center;
}


.pageHeaderPg .notification-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ff8c2f;
  padding: 20px 30px;
  color: white;
  background-image: url('../../assets/images/notiBanner.png');
  background-repeat: no-repeat;
  background-size: cover;
  flex-wrap: wrap;
  cursor: pointer;
  overflow: hidden;
  /* important for marquee */
}

.pageHeaderPg .notification-message {
  font-size: 1.5rem;
  font-weight: 400;
  cursor: pointer;
  white-space: nowrap;
  margin-left: 5rem;
  margin-right: 5rem;
  /* helps in marquee */
}

/* Medium screens - tablets */
@media (max-width: 880px) {
  .pageHeaderPg .notification-banner {
    background-image: url('../../assets/images/notibanner-responsive.png');
    flex-direction: column;
    align-items: flex-start;
    padding: 10px 15px;
    text-align: left;
  }

  .pageHeaderPg .notification-message {
    font-size: 1.2rem;
    animation: scroll-left 15s linear infinite;
    display: inline-block;
  }
}

/* Small screens - mobile devices */
@media (max-width: 480px) {
  .pageHeaderPg .notification-banner {
    background-image: url('../../assets/images/notibanner-responsive.png');
    padding: 7px 12px;
  }

  .pageHeaderPg .notification-message {
    font-size: 1rem;
  }
}

/* Marquee animation only for mobile/tablet */
@keyframes scroll-left {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(-100%);
  }
}


.pageHeaderPg-modal-top-image {
  width: 100px;
  height: 100px;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}

.pageHeaderPg-modal-title {
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
}

.pageHeaderPg-modal-content-text {
  font-size: 1rem;
  line-height: 1.6;
  text-align: center;
}

.pageHeaderPg-modal-content-text a {
  color: #092e87;
}

.pageHeaderPg-modal-button {
  display: block;
  width: 100%;
  max-width: 200px;
  margin: 30px auto 0 auto;
  /* top margin for spacing, center align */
  padding: 10px 20px;
  background-color: #092e87;
  color: white;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.pageHeaderPg-modal-button:hover {
  background-color: #092f87af;
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .pageHeaderPg-modal-top-image {
    width: 70px;
    height: 70px;
  }

  .pageHeaderPg-modal-title {
    font-size: 1.25rem;
  }

  .pageHeaderPg-modal-content-text {
    font-size: 0.95rem;
  }

  .pageHeaderPg-modal-button {
    max-width: 50%;
    font-size: 0.95rem;
    padding: 10px 16px;
    border-radius: 50px;
  }
}
</style>